/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApiError,
    ApiErrorFromJSON,
    ApiErrorToJSON,
    GetBusinessOwnEnabledStatus,
    GetBusinessOwnEnabledStatusFromJSON,
    GetBusinessOwnEnabledStatusToJSON,
    GetPromoTokensResponse,
    GetPromoTokensResponseFromJSON,
    GetPromoTokensResponseToJSON,
    GetPromoTokensSort,
    GetPromoTokensSortFromJSON,
    GetPromoTokensSortToJSON,
    PromoToken,
    PromoTokenFromJSON,
    PromoTokenToJSON,
    PromoTokenBody,
    PromoTokenBodyFromJSON,
    PromoTokenBodyToJSON,
    PromoTokenType,
    PromoTokenTypeFromJSON,
    PromoTokenTypeToJSON,
    SortOrder,
    SortOrderFromJSON,
    SortOrderToJSON,
} from '../models';

export interface CreatePromoTokenRequest {
    promoTokenBody?: PromoTokenBody;
}

export interface GetPromoTokenRequest {
    id: string;
}

export interface GetPromoTokensRequest {
    type?: Array<PromoTokenType>;
    search?: string;
    sort?: GetPromoTokensSort;
    isEnabled?: GetBusinessOwnEnabledStatus;
    order?: SortOrder;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface UpdatePromoTokenRequest {
    id: string;
    promoTokenBody?: PromoTokenBody;
}

/**
 * PromoTokensApi - interface
 * @export
 * @interface PromoTokensApiInterface
 */
export interface PromoTokensApiInterface {
    /**
     * Used by admins to create new promo token.
     * @param {PromoTokenBody} [promoTokenBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoTokensApiInterface
     */
    createPromoTokenRaw(requestParameters: CreatePromoTokenRequest): Promise<runtime.ApiResponse<void>>;

    /**
     * Used by admins to create new promo token.
     */
    createPromoToken(requestParameters: CreatePromoTokenRequest): Promise<void>;

    /**
     * Used to get a single promo token.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoTokensApiInterface
     */
    getPromoTokenRaw(requestParameters: GetPromoTokenRequest): Promise<runtime.ApiResponse<PromoToken>>;

    /**
     * Used to get a single promo token.
     */
    getPromoToken(requestParameters: GetPromoTokenRequest): Promise<PromoToken>;

    /**
     * Used to get a list of all promo tokens
     * @param {Array<PromoTokenType>} [type] 
     * @param {string} [search] 
     * @param {GetPromoTokensSort} [sort] 
     * @param {GetBusinessOwnEnabledStatus} [isEnabled] 
     * @param {SortOrder} [order] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoTokensApiInterface
     */
    getPromoTokensRaw(requestParameters: GetPromoTokensRequest): Promise<runtime.ApiResponse<GetPromoTokensResponse>>;

    /**
     * Used to get a list of all promo tokens
     */
    getPromoTokens(requestParameters: GetPromoTokensRequest): Promise<GetPromoTokensResponse>;

    /**
     * Used by admins to update existing promo token.
     * @param {string} id 
     * @param {PromoTokenBody} [promoTokenBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoTokensApiInterface
     */
    updatePromoTokenRaw(requestParameters: UpdatePromoTokenRequest): Promise<runtime.ApiResponse<void>>;

    /**
     * Used by admins to update existing promo token.
     */
    updatePromoToken(requestParameters: UpdatePromoTokenRequest): Promise<void>;

}

/**
 * no description
 */
export class PromoTokensApi extends runtime.BaseAPI implements PromoTokensApiInterface {

    /**
     * Used by admins to create new promo token.
     */
    async createPromoTokenRaw(requestParameters: CreatePromoTokenRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Admin", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/promo-tokens`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PromoTokenBodyToJSON(requestParameters.promoTokenBody),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used by admins to create new promo token.
     */
    async createPromoToken(requestParameters: CreatePromoTokenRequest): Promise<void> {
        await this.createPromoTokenRaw(requestParameters);
    }

    /**
     * Used to get a single promo token.
     */
    async getPromoTokenRaw(requestParameters: GetPromoTokenRequest): Promise<runtime.ApiResponse<PromoToken>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getPromoToken.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Optional", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/promo-tokens/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PromoTokenFromJSON(jsonValue));
    }

    /**
     * Used to get a single promo token.
     */
    async getPromoToken(requestParameters: GetPromoTokenRequest): Promise<PromoToken> {
        const response = await this.getPromoTokenRaw(requestParameters);
        return await response.value();
    }

    /**
     * Used to get a list of all promo tokens
     */
    async getPromoTokensRaw(requestParameters: GetPromoTokensRequest): Promise<runtime.ApiResponse<GetPromoTokensResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.type) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.isEnabled !== undefined) {
            queryParameters['isEnabled'] = requestParameters.isEnabled;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.numberOfAvailableOffsets !== undefined) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters.numberOfAvailableOffsets;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Admin", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/promo-tokens`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPromoTokensResponseFromJSON(jsonValue));
    }

    /**
     * Used to get a list of all promo tokens
     */
    async getPromoTokens(requestParameters: GetPromoTokensRequest): Promise<GetPromoTokensResponse> {
        const response = await this.getPromoTokensRaw(requestParameters);
        return await response.value();
    }

    /**
     * Used by admins to update existing promo token.
     */
    async updatePromoTokenRaw(requestParameters: UpdatePromoTokenRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updatePromoToken.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Admin", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/promo-tokens/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PromoTokenBodyToJSON(requestParameters.promoTokenBody),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used by admins to update existing promo token.
     */
    async updatePromoToken(requestParameters: UpdatePromoTokenRequest): Promise<void> {
        await this.updatePromoTokenRaw(requestParameters);
    }

}
